import { Col, Row } from 'antd';
import clsx from 'clsx';
import React, { FC, ReactNode } from 'react';
import styles from './fieldLabel.module.scss';

export interface FieldLabelProps {
  showLabel?: boolean;
  name: string;
  error?: boolean;
  label?: ReactNode;
}

const FieldLabel: FC<FieldLabelProps> = ({ showLabel, name, error, label }) => {
  const labelClass = clsx({
    [styles.labelFloat]: true,
    [styles.error]: !!error,
  });
  return (
    <Row>
      <Col span={24}>
        {showLabel && (
          <label htmlFor={name} className={labelClass}>
            {label}
          </label>
        )}
      </Col>
    </Row>
  );
};

export default FieldLabel;
